import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetType } from '../base/widget/WidgetTypes'

export const WidgetHeader: Widget = {
  type: WidgetType.header,
  isFrameless: true,
  title: 'Überschrift',
  minSize: 1,
  defaultSize: 8,
  icon: 'FormatHeader1',
  customSettings: {
    settings: {
      textAlign: { type: WidgetSettingType.selectbox, title: 'Textausrichtung', value: 0, options: [
          { label: 'Linksbündig', value: 0 },
          { label: 'Zentriert', value: 1 },
          { label: 'Rechtsbündig', value: 2 }
      ] },
      fontSize: { type: WidgetSettingType.selectbox, title: 'Schriftgröße', value: 0, options: [
          { label: 'Standard', value: 0 },
          { label: 'Groß', value: 1 },
          { label: 'Sehr groß', value: 2 }
      ] }
    }
  }
}

export default WidgetHeader
